import React from 'react';

import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import KOGPaginationGrid from '@/main/components/shared/paginationGrid/paginationGrid';

import { procurementReportApi } from '@/main/api';
import { SearchGridSupplierPerformanceRequest } from '@/main/models/request';
import { SupplierPerformanceReportResponse } from '@/main/models/response';
import { getTranslateByKey } from '@/main/services/utils';

import RowDataSupplierPerfomance from './rowDataSupplierPerfomance/rowDataSupplierPerfomance';
import * as S from './styles';
import { userIsSupplier } from '@/main/services/utilsUser';

interface IGridSupplierPerformanceProps {
  dataGrid: SupplierPerformanceReportResponse[];
  formFilters: SearchGridSupplierPerformanceRequest | null;
  setDataGrid: React.Dispatch<React.SetStateAction<any[]>>;
}

function GridSupplierPerformance({
  dataGrid,
  formFilters,
  setDataGrid
}: IGridSupplierPerformanceProps) {
  const rowsHeader = [
    getTranslateByKey('information.supplier'),
    getTranslateByKey('information.tradeName'),
    <S.TextCenter>{getTranslateByKey('information.totalpartssent')}</S.TextCenter>,
    <S.TextCenter>{getTranslateByKey('information.totalpartsanswered')}</S.TextCenter>,
    <S.TextCenter>{getTranslateByKey('information.partsmanually')}</S.TextCenter>,
    <S.TextCenter>{getTranslateByKey('information.partsautomatically')}</S.TextCenter>,
    <S.TextCenter>{getTranslateByKey('information.partsassigned')}</S.TextCenter>,
    <S.TextCenter>{getTranslateByKey('information.partscancelreturn')}</S.TextCenter>,
    userIsSupplier() ? false : <S.TextCenter>{getTranslateByKey('information.partstransfered')}</S.TextCenter>,
    <S.TextCenter>{getTranslateByKey('information.%answered')}</S.TextCenter>,
    <S.TextCenter>{getTranslateByKey('information.%assigned')}</S.TextCenter>,
  ].filter(Boolean);

  const RowsGroup = [
    '20%', // Supplier
    '20%', // Trade Name
    '100px', // Total Parts Sent
    '100px', // Total Parts Answered
    '100px', // Parts Answered Manually
    '100px', // Parts Answered Automatically
    '100px', // Parts Assigned
    '100px', // Parts Canceled And Returned
    userIsSupplier() ? false : '100px', // Parts Transfered
    '80px', // Answered Porcentage
    '80px' // Assigned Porcentage
  ].filter(Boolean) as string[];

  async function fetchDataGrid(request: any) {
    return procurementReportApi.searchGridSupplierPerformance(request).then(response => response.data);
  }

  if (dataGrid.length === 0 && formFilters === null) return null

  return (
    <S.Container>
      <KOGPaginationGrid
        showTitleResults
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
        fetchMore={fetchDataGrid}
      >
        <BoxGrid
          rowHeaders={rowsHeader}
          sizeColumns={RowsGroup}
          sizeCell='medium'
          breakpointTable={1100}
        >
          {dataGrid.map((item, index) =>
            <RowDataSupplierPerfomance
              key={'row-data-filter-perfomance-' + index}
              itemRow={item}
            />
          )}
        </BoxGrid>
      </KOGPaginationGrid>
    </S.Container>
  )
}

export default GridSupplierPerformance